/** 存储websocket地址 */
const websocketUrl = {
  cradle_head: "/websocket/holder", //云台
  video_task: "/websocket/taskLog/start", //视频任务
  video_check: "/websocket/video" //挂机检测
};

export default websocketUrl;
